// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import Vconsole from 'vconsole'
import { setMd } from '@/utils/maidian/zzdmd.js'
import '@/assets/style/common.css'
import '@/assets/style/reset.css'
// if (process.env.NODE_ENV !== 'production') { // 测试和开发打开，生产不能打开
if (localStorage.getItem('OpenVconsole')) {
  // 测试和开发打开，生产不能打开
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}

Vue.use(Vant)

Vue.config.productionTip = false

// 生成环境走埋点
if (process.env.NODE_ENV == 'production') {
  router.beforeEach((to, from, next) => {
    console.log('to---', to)
    console.log('form---', from)
    const token = sessionStorage.getItem('token')
    if (!token && to.path !== '/login') {
      next('/login')
    } else if (to.path !== '/') {
      console.log('埋点-----')
      // 埋点
      let { id, title } = to.meta
      setMd(id, title, to.path)
      next()
    } else {
      next()
    }
  })
}
// else {
//   router.beforeEach((to, from, next) => {
//     const token = sessionStorage.getItem('token')
//     if (!token && to.path !== '/login') {
//       next('/login')
//     } else {
//       next()
//     }
//   })
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js